/**
 * The doors into Import a spreadsheet (KPR-1899). The page is
 * `components/import/SpreadsheetImportPage`; this says how a door builds its
 * address, so a collection's ⋯, a card's ⋯, the Add item modal, the empty state
 * and Settings → Imports all go to the same place.
 */

export const IMPORT_LABEL = 'Import a spreadsheet';

/** `/collections/:id/import`, with `?card=` when the door knows the card. */
export function importPath(collectionId, cardId = null) {
	const base = `/collections/${collectionId}/import`;
	return cardId ? `${base}?card=${encodeURIComponent(cardId)}` : base;
}
